import React, { useEffect, useRef } from 'react';
import { setSeoMetadata } from '../lib/seo';
import TransferSend from '../tools/transfer/TransferSend';

// Bare page for iframing on a client's own site: no site header/footer. The
// server only lets origins listed in Dev Settings -> Transfer frame this path.
const TransferEmbedPage = () => {
  const mainRef = useRef(null);

  useEffect(() => {
    setSeoMetadata({ title: 'Send files', noIndex: true });
  }, []);

  // The embed sits on the client's page: no page background of ours behind the card.
  useEffect(() => {
    const els = [document.documentElement, document.body];
    const prev = els.map((el) => el.style.background);
    els.forEach((el) => { el.style.background = 'transparent'; });
    return () => els.forEach((el, i) => { el.style.background = prev[i]; });
  }, []);

  // Tell the embedding page how tall this is, so embed.js can size the iframe to fit (no scrollbars,
  // no empty gap). The message carries only a number, so '*' as the target origin leaks nothing.
  useEffect(() => {
    if (window.parent === window || !mainRef.current || typeof ResizeObserver === 'undefined') return undefined;
    const send = () => window.parent.postMessage({ type: 'a2g-transfer-height', height: mainRef.current.offsetHeight }, '*');
    const ro = new ResizeObserver(send);
    ro.observe(mainRef.current);
    send();
    return () => ro.disconnect();
  }, []);

  return (
    <main ref={mainRef} className="mx-auto w-full max-w-[408px] p-3">
      <h1 className="sr-only">Send files</h1>
      <TransferSend skin="light" embedded />
    </main>
  );
};

export default TransferEmbedPage;
